import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const createBooking = (data) => api.post("/bookings", data).then((r) => r.data);
export const createEnquiry = (data) => api.post("/enquiries", data).then((r) => r.data);

export const adminLogin = (key) => api.post("/admin/login", { key }).then((r) => r.data);

const authHeader = (key) => ({ headers: { "X-Admin-Key": key } });

export const getBookings = (key) => api.get("/bookings", authHeader(key)).then((r) => r.data);
export const getBookingStats = (key) => api.get("/bookings/stats", authHeader(key)).then((r) => r.data);
export const updateBookingStatus = (id, status, key) =>
  api.patch(`/bookings/${id}/status`, { status }, authHeader(key)).then((r) => r.data);
export const deleteBooking = (id, key) => api.delete(`/bookings/${id}`, authHeader(key)).then((r) => r.data);
export const getEnquiries = (key) => api.get("/enquiries", authHeader(key)).then((r) => r.data);

// Articles / Blog
export const getArticles = (all = false) => api.get(`/articles${all ? "?all=true" : ""}`).then((r) => r.data);
export const getArticle = (slug) => api.get(`/articles/${slug}`).then((r) => r.data);
export const createArticle = (data, key) => api.post("/articles", data, authHeader(key)).then((r) => r.data);
export const updateArticle = (id, data, key) => api.put(`/articles/${id}`, data, authHeader(key)).then((r) => r.data);
export const deleteArticle = (id, key) => api.delete(`/articles/${id}`, authHeader(key)).then((r) => r.data);

// Complaints & Lost property
export const createComplaint = (data) => api.post("/complaints", data).then((r) => r.data);
export const createLostProperty = (data) => api.post("/lost-property", data).then((r) => r.data);
export const getComplaints = (key) => api.get("/complaints", authHeader(key)).then((r) => r.data);
export const getLostProperty = (key) => api.get("/lost-property", authHeader(key)).then((r) => r.data);

// Corporate accounts
export const createCorporateAccount = (data) => api.post("/corporate-accounts", data).then((r) => r.data);
export const getCorporateAccounts = (key) => api.get("/corporate-accounts", authHeader(key)).then((r) => r.data);
export const approveCorporateAccount = (id, key) =>
  api.post(`/corporate-accounts/${id}/approve`, {}, authHeader(key)).then((r) => r.data);

// Live wait subscription
export const subscribeLiveWait = (data) => api.post("/live-wait/subscribe", data).then((r) => r.data);
